import React, { Component } from 'react';
import Header from './Header';
import { Card, CardTitle, CardText, Button , TextField} from 'react-md';


class Login extends Component {
    constructor(props) {
        super(props)
        this.state ={
            email: '',
            password: ''
        }
        this.signInEmail =this.signInEmail.bind(this);
        this.emailChanged =this.emailChanged.bind(this);
        this.passwordChanged =this.passwordChanged.bind(this);
        this.loginWithEmail =this.loginWithEmail.bind(this);
        this.signUp =this.signUp.bind(this);
    }
    signInEmail(event, type){
        event.preventDefault();
        (type === 'signIn')? this.loginWithEmail(this.state.email, this.state.password):this.signUp(this.state.email, this.state.password);
    }
    passwordChanged(event){
        this.setState ({ password: event})
    }
    emailChanged(event){
        this.setState ({ email: event});
    }

    loginWithEmail(email, pass){
        
        this.props.service.a.signInWithEmailAndPassword(email, pass).catch(function(error) {
            console.error('Error signing in with email and password.', error);
          });
    }
    signUp(email, pass){
        this.props.service.a.createUserWithEmailAndPassword(email, pass).catch(function(error) {
            console.error('Error signing up with email and password.', error);
          });
    }

    popUpLogin = (provider) => {
        let p;
        switch (provider) {
            case 'google':
                p = new this.props.service.f.auth.GoogleAuthProvider();
                break;
        
            default:
                break;
        }
        this.props.service.a.signInWithPopup(p).then(function(result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            //var token = result.credential.accessToken;
            // The signed-in user info.
            var user = result.user;
            console.debug('Signed in.', user.displayName);

        }).catch(function(error){
            console.error("Login Error: ", error);
        });
    }
    
    render(){

        return (
            <div>
                <Header title="Welcome to D6" />
                <Card className="md-block-centered  md-cell md-cell--4 md-cell--center md-text-center absolute-center">
                    <CardTitle title="Welcome!" className="md-cell md-cell--12" subtitle="Please Loging to start" />
                    <CardText>
                        <form id="EmailSignin">
                        <TextField
                            id="signIn_email"
                            label="Email"
                            lineDirection="center"
                            className=""
                            value={this.state.email}
                            onChange={this.emailChanged}
                        />
                        <TextField
                            id="signIn_pass"
                            label="Enter your password"
                            type="password"
                            className=""
                            value={this.state.password}
                            onChange={this.passwordChanged}
                        />
                         <Button raised primary  onClick={(event)=>this.signInEmail(event, 'signIn')}>Sign In</Button>
                         <Button raised primary  onClick={(event)=>this.signInEmail(event, 'signUp')}>Sign Up</Button>
                        </form>
                        <div className="md-block-centered  md-text-align-center" style={{'margin': '10px 0'}}>Or</div>
                        <Button raised onClick={() => this.popUpLogin('google')}>Sign In with Google</Button>
                    </CardText>
                    
                </Card>
            </div>
        )

    }
}

export default Login


// WEBPACK FOOTER //
// ./src/Login.jsx